export default {
  title: 'Reset',

  counts: {
    costs: '"{count}" costs exist',
    documents: '"{count}" documents exist',
    financial_years: '"{count}" financial years exist',
    internal_funds: '"{count}" internal funds exist',
    invoices: '"{count}" invoices exist',
    opening_inventories: '"{count}" opening inventories exist',
    payments: '"{count}" payments exist',
    receives: '"{count}" receives exist',
    storeroom_receipts: '"{count}" warehouse pull in exist'
  },

  labels: {
    companyName: 'Name',
    confirm: 'Confirm, reset app',
    codeValidate: 'Code validity ',
    second: 'Second',
    resendCode: 'Resend Code',
    storedData: 'You are about to reset app containing:',
    resetConfirm: 'Are you absolutely sure?',
    enterConfirm: 'Enter the following to confirm:'
  },

  notifications: {
    otpExpired: 'Code expired',
    otpWrong: 'Code is wrong',

    sendOtp: {
      success: 'The verification code of reset app was sms to your phone number.',
      error: 'Send verification code of reset app has error',
      unSaveChanges: 'There are some unsaved changes in app'
    },
    confirmReset: {
      success: 'Reset app successFully done',
      error: 'Reset app has error'
    }
  },

  confirmations: {
    reset: {
      title: 'Reset app',
      body: 'Are you sure about reset app?'
    }
  }
}
